import React, { ReactNode } from 'react';
import { FileViewerProvider } from './FileViewer';
import TEV3Layout from './tev3';

interface RootLayoutProps {
  children: ReactNode;
}

export const RootLayout: React.FC<RootLayoutProps> = ({ children }) => {
  return (
    <FileViewerProvider>
      <TEV3Layout>
        {children}
      </TEV3Layout>
    </FileViewerProvider>
  );
};

// Layout without TEV3 wrapper (for login page)
export const MinimalLayout: React.FC<RootLayoutProps> = ({ children }) => {
  return (
    <FileViewerProvider>
      {children}
    </FileViewerProvider>
  );
};
